let RE = {
    game:'archero2',

    url: '',  //跳转地址
    iosUrl: 'https://apps.apple.com/us/app/archero-2/id6502820653',  //默认地址
    AndUrl: 'https://play.google.com/store/apps/details?id=com.xq.archeroii',  //默认地址

    track: 'archero2',       //打点名称
    sandbox: null,  //是否是沙盒环境

    email: 'archero2@habby.com',
    options: [
        {
            value: 'en',
            label: 'English'
        },
        {
            value: 'ja',
            label: '日本語'
        },
        {
            value: 'ko',
            label: '한국어'
        },
        {
            value: 'zh-TW',
            label: '繁體中文'
        }
    ],
}

// console.log(RE, 'RE');

module.exports = RE;



// WEBPACK FOOTER //
// ./src/assets/replace.js